import { translate } from 'App/Internationalization';
import FieldSearchableSelect from 'shared/Forms/Fields/FieldSearchableSelect';
import React from 'react';

/**
 * @typedef {{ id: string; name: string }} AgentOption
 * @typedef {{
 * 	agent?: AgentOption | null,
 * 	agentList?: AgentOption[] | null,
 * }} InitialGroupValues
 * @typedef {{
 * 	agentList?: AgentOption[] | null,
 * 	className?: string,
 * 	initialGroupValues?: InitialGroupValues | null,
 * }} Props
 */

/** @extends {React.Component<Props>} */
class GroupAgentFieldGroup extends React.Component {
	/**
	 * @param {AgentOption | null | undefined} object
	 * @returns {{label: string; value: string} | null}
	 */
	static mapToOption(object) {
		if (!object?.id || !object?.name) {
			return null;
		}

		return {
			label: object.name,
			value: object.id,
		};
	}

	render() {
		/** @type {{id: string; name: string}[]} */
		const agentList =
			this.props.initialGroupValues?.agentList ??
			this.props.agentList ??
			[];

		return (
			<FieldSearchableSelect
				className={this.props.className}
				defaultValue={GroupAgentFieldGroup.mapToOption(
					this.props.initialGroupValues?.agent ?? null
				)}
				label={translate('admin.pages.contacts.form.agent.label')}
				name="agentId"
				options={agentList.map((agent) =>
					GroupAgentFieldGroup.mapToOption(agent)
				)}
				required={true}
			/>
		);
	}
}

export default GroupAgentFieldGroup;
